var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectors6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 852,
    height: 852,
    viewBox: "0 0 852 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.332 80.7055C286.79 45.7999 355.368 27.4167 425.18 27.4021C494.991 27.3875 563.577 45.742 624.05 80.6222L425.263 425.264L226.332 80.7055Z",
    fill: "url(#paint0_linear_61_22)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4016 425.264C27.4016 355.453 45.7705 286.871 80.6634 226.405C115.556 165.94 165.745 115.72 226.189 80.7886L425.264 425.264L27.4016 425.264Z",
    fill: "url(#paint1_linear_61_22)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M823.127 425.958C823.005 495.77 804.517 564.32 769.518 624.724C734.52 685.129 684.244 735.261 623.739 770.087L425.265 425.264L823.127 425.958Z",
    fill: "url(#paint2_linear_61_22)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M624.195 80.7049C684.654 115.61 734.863 165.81 769.781 226.26C804.7 286.711 823.097 355.286 823.126 425.097L425.264 425.264L624.195 80.7049Z",
    fill: "url(#paint3_linear_61_22)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M226.334 769.824C165.875 734.918 115.666 684.719 80.7475 624.268C45.8293 563.817 27.4317 495.242 27.4024 425.431L425.265 425.265L226.334 769.824Z",
    fill: "url(#paint4_linear_61_22)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M624.196 769.823C563.738 804.728 495.159 823.112 425.348 823.126C355.537 823.141 286.951 804.786 226.478 769.906L425.265 425.264L624.196 769.823Z",
    fill: "url(#paint5_linear_61_22)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_22",
    x1: 273.754,
    y1: 228.428,
    x2: 482.665,
    y2: 135.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_22",
    x1: 179.045,
    y1: 458.056,
    x2: 352.276,
    y2: -11.4222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_22",
    x1: 676.431,
    y1: 416.798,
    x2: 602.569,
    y2: 634.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_61_22",
    x1: 543.128,
    y1: 203.309,
    x2: 871.776,
    y2: 634.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_61_22",
    x1: 330.554,
    y1: 654.893,
    x2: 145.962,
    y2: 520.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_61_22",
    x1: 567.604,
    y1: 622.696,
    x2: 31.7764,
    y2: 707.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectors6);
export default __webpack_public_path__ + "static/media/sectors-6.2f86c49561b6199355e157fd4d47ad9c.svg";
export { ForwardRef as ReactComponent };